import {ICalendarDateParams, TCalendarCell, TCalendarMY} from "../types";


export function getLastDayOfMonth(month: number, year: number) {
  const date = new Date(year, month + 1, 0);
  return date.getDate();
}

export function getDateSlice(month: number, year: number): Array<TCalendarCell> {
  const firstDayID = new Date(year, month, 0).getDay();
  const days = getLastDayOfMonth(month, year);
  return Array.from(Array(days)).map((_, id) => {
    return {
      dayInWeek: ((id + firstDayID) % 7) + 1,
      dayID: id + firstDayID,
      day: id + 1,
      month: month + 1,
      year
    }
  });
}

export function getDateParams(date: Date): ICalendarDateParams {
  return {
    year: date.getFullYear(),
    month: date.getMonth(),
    day: date.getDate()
  }
}

export function getCalendarCellsData(
  month: number,
  year: number,
  cellsAmount: number,
  monthInYear: number
) {
  const currentMonthData: Array<TCalendarCell> = getDateSlice(month, year);

  const {dayID: firstDayID} = currentMonthData[0];
  const {dayID: lastDayID} = currentMonthData[currentMonthData.length - 1];

  const prev = month - 1 < 0
    ? {month: monthInYear - 1, year: year - 1 }
    : {month: month - 1, year};
  const next = month + 1 > monthInYear - 1
    ? {month: 0, year: year + 1}
    : {month: month + 1, year};

  const previousMonthData: Array<TCalendarCell> = getDateSlice(prev.month, prev.year);
  const nextMonthData: Array<TCalendarCell> = getDateSlice(next.month, next.year);

  const prevSliced = previousMonthData.slice(previousMonthData.length - firstDayID);
  const nextSliced = nextMonthData.slice(0, cellsAmount - lastDayID - 1);


  return [...prevSliced, ...currentMonthData, ...nextSliced];
}

export function getPMYPair(currentMonthID: number, currentYear: number, monthInYear: number): TCalendarMY {
  return currentMonthID - 1 < 0
    ? {
      year: currentYear - 1,
      month: monthInYear - 1
    }
    : {
      year: currentYear,
      month: currentMonthID - 1
    }
}

export function getNMYPair(currentMonthID: number, currentYear: number, monthInYear: number): TCalendarMY {
  return currentMonthID + 1 > monthInYear - 1
    ? {
      year: currentYear + 1,
      month: 0
    }
    : {
      year: currentYear,
      month: currentMonthID + 1
    }
}

export function getPrevMonth(currentMonthID: number, monthInYear: number) {
  return currentMonthID - 1 < 0 ? monthInYear - 1 : currentMonthID - 1;
}

export function getNextMonth(currentMonthID: number, monthInYear: number) {
  return currentMonthID + 1 > monthInYear - 1 ? 0 : currentMonthID + 1;
}


export function generateMonthCalendarData(date: Date): Array<TCalendarCell> {
  const year = date.getFullYear();
  return Array(12).fill(0).map((_, index) => {
    return {
      dayInWeek: 7,
      dayID: 0,
      day: 1,
      month: index + 1,
      year: year,
    }
  })
}
